import React, { useEffect, useRef, useState } from 'react'

export default function GamesFilterPopup(props) {
  const popupRef = useRef()
  const filterButtonRef = useRef()
  const [showPopup, setShowPopup] = useState(false)
  const filter = props.filter
  const sort = filter.sort

  let overPopup = false
  let timer = null

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (showPopup && popupRef.current && !popupRef.current.contains(e.target) && !filterButtonRef.current.contains(e.target)) {
        setShowPopup(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [showPopup])

  const sortClass = (name) => {
    if (!sort[name]) return 'arrow'
    return sort[name] == 'asc' ? 'arrow arrow-sort-asc' : 'arrow arrow-sort-desc' 
  }

  const onSort = (name) => {
    var newSort = {}
    if (!sort[name]) newSort = { [name]: 'asc' }
    else if (sort[name] == 'asc') newSort = { [name]: 'desc' }
    else newSort = { [name]: 'asc' }

    props.setFilter({...filter, sort: newSort})
  }

  const onHide = (name, checked) => {
    var newFilter = {...filter}
    newFilter[name] = checked

    props.setFilter(newFilter)
  }

  const onShowPopup = () => {
    setShowPopup(true)
  }

  const onHidePopup = () => {
    clearTimeout(timer)
    timer = setTimeout(() => { 
      if (!overPopup) setShowPopup(false) 
    }, 200)
  }

  const onEnterPopup = () => {
    overPopup = true
  }

  const onLeavePopup = () => {
    overPopup = false
    setShowPopup(false)
  }

  return <div>
    <div 
      className={'open-games-filter' + (filter.isDisabled() ? ' disabled' : '')} 
      onMouseEnter={onShowPopup}
      onMouseLeave={onHidePopup}
      ref={filterButtonRef} 
      onClick={() => setShowPopup(!showPopup)}
    >
    </div>
    { showPopup &&
      <div
        className='filter-popup'
        ref={popupRef}
        onMouseEnter={onEnterPopup}
        onMouseLeave={onLeavePopup}
      >
        <label onClick={() => onSort('time')}>
          <div className={sortClass('time')}></div>
          <span>Sort by Time</span>
        </label>
        <label onClick={() => onSort('number_of_players')}>
          <div className={sortClass('number_of_players')}></div>
          <span>Sort by Spots filled</span>
        </label>
        <div className='separator'></div>
        <label>
          <input
            type='checkbox'
            checked={filter.hideOrganizerGames}
            onChange={(e) => onHide('hideOrganizerGames', e.target.checked)}
          />
          <span>Hide Organizer Games</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideHappening}
            onChange={(e) => onHide('hideHappening', e.target.checked)}
          />
          <span>Hide Games Happening</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideEnded}
            onChange={(e) => onHide('hideEnded', e.target.checked)}
          />
          <span>Hide Games Ended</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideConfirmed}
            onChange={(e) => onHide('hideConfirmed', e.target.checked)}
          />
          <span>Hide Confirmed Games</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideToDoComplete}
            onChange={(e) => onHide('hideToDoComplete', e.target.checked)}
          />
          <span>Hide To Do Complete</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideSeen}
            onChange={(e) => onHide('hideSeen', e.target.checked)}
          />
          <span>Unseen Messages</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hideNotDeclined}
            onChange={(e) => onHide('hideNotDeclined', e.target.checked)}
          />
          <span>Declined Payments</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.fakesOff}
            onChange={(e) => onHide('fakesOff', e.target.checked)}
          />
          <span>Included Fakes Off</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.newFacilities}
            onChange={(e) => onHide('newFacilities', e.target.checked)}
          />
          <span>Show New Facilities</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.confirmedWithFacility}
            onChange={(e) => onHide('confirmedWithFacility', e.target.checked)}
          />
          <span>Hide Confirmed With Facility</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.requiresCaptain}
            onChange={(e) => onHide('requiresCaptain', e.target.checked)}
          />
          <span>Requires Captain</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.hasCaptain}
            onChange={(e) => onHide('hasCaptain', e.target.checked)}
          />
          <span>Has Captain</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.missingCaptain}
            onChange={(e) => onHide('missingCaptain', e.target.checked)}
          />
          <span>Missing Captain</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.fullWithFakes}
            onChange={(e) => onHide('fullWithFakes', e.target.checked)}
          />
          <span>Full with Fakes</span>
        </label>
        <label>
          <input
            type='checkbox'
            checked={filter.lowRating}
            onChange={(e) => onHide('lowRating', e.target.checked)}
          />
          <span>Low Rating</span>
        </label>
      </div>
    }
  </div>
}
